export default ['house', 'country_house', 'cottage', 'townhouse'];
